import { useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrderedCatsUnits } from '@store/partners-order/selectors';
import { updateOrderedCatsUnitsItem } from '@store/partners-order/slice';
import SizeItem from '@pages/partners-order/sizes-units/SizeItem';
import TestSamples from '@pages/partners-order/sizes-units/TestSamples';



const CatsSizesGrid = () => {
	
	const orderedCatsUnits = useSelector(selectOrderedCatsUnits);
	const dispatch = useDispatch();
	const updateCatsUnitsItem = (label: string, value: number) => dispatch(updateOrderedCatsUnitsItem({ label, value }));


	const sizesArray = useMemo((): Array<{ label: string, value: number }> => {
		return [
			{ label: 'S', value: orderedCatsUnits.sizeS },
			{ label: 'M', value: orderedCatsUnits.sizeM },
			{ label: 'L', value: orderedCatsUnits.sizeL },
		];
	},[ orderedCatsUnits ]);

	
	return (
		<div className='cats-sizes-grid'>
			{sizesArray.map(x =>
				<SizeItem
					label={x.label}
					count={x.value}
					onClick={updateCatsUnitsItem}
					key={`size-item-cat-${x.label}`} />)}

			<TestSamples />
		</div>
	);
};

export default memo(CatsSizesGrid);